// TODO enable eslint
/* eslint-disable react/jsx-curly-brace-presence */
import React, { Component } from "react"
import moment from "moment"
import get from "lodash/get"
import cn from "classnames"
import { Transition } from "react-transition-group"
import noop from "lodash/noop"
import { compose, lifecycle } from "recompact"
import { selectViolationsList } from "src/engine/modules/validate/selectors"
import { selectStatusAvailable } from "src/engine/modules/features/selectors"
import { connect } from "react-redux"
import { defaultMemoize } from "reselect"
import { LockedIcon } from "@infotech/uikit-icons"
import { Box } from "@infotech/uikit-grid"
import { errorStyle, warningStyle, lockedStyle } from "src/helpers/invalidStyle"
import { makeTransparent } from "src/containers/Calendar/helpers/eventToItem"
import tooltip from "@infotech/uikit-tooltip"
import { contextConsumer } from "../CardOverlay"

import styles from "./styles.css"

const TooltipSpan = tooltip.span()

const EVENT_WITH_STATUS_WIDTH = 24
const EVENT_WITH_STATUS_TOOLTIP = 44

const calculateRelativeLeftOffset = (
  startTime,
  relativeTime,
  timelineWidth,
  timelineStartTime,
  timelineEndTime,
) => {
  const pxToTimeRatio = timelineWidth / (timelineEndTime - timelineStartTime)

  const itemVisibleStartTime = Math.max(startTime, timelineStartTime)

  const itemOffset = (itemVisibleStartTime - timelineStartTime) * pxToTimeRatio
  const relativeTimeLeftOffset =
    (relativeTime - timelineStartTime) * pxToTimeRatio

  return relativeTimeLeftOffset - itemOffset
}

class EventCard extends Component {
  calculateEventStyleObj = defaultMemoize(
    (start, end, timelineWidth, visibleTimeStart, visibleTimeEnd) => {
      const way = end - start
      const pointTime = moment(start + way).valueOf()
      const itemOffsetLeft = calculateRelativeLeftOffset(
        start,
        pointTime,
        timelineWidth,
        visibleTimeStart,
        visibleTimeEnd,
      )
      let itemPadding = itemOffsetLeft > 42 ? `0 12px` : `0 6px`

      // Hide any content if item is too small to display anything
      if (itemOffsetLeft < 24) {
        itemPadding = `0 24px`
      }

      return {
        maxWidth: itemOffsetLeft,
        padding: itemPadding,
      }
    },
  )

  handleRightHandleMouseDown = e => {
    e.stopPropagation() // Prevent body mouse down from triggering
    const {
      item: { onRightHandlerMouseDown = noop },
    } = this.props

    return onRightHandlerMouseDown(e)
  }

  handleLeftHandleMouseDown = e => {
    e.stopPropagation() // Prevent body mouse down from triggering
    const {
      item: { onLeftHandlerMouseDown = noop },
    } = this.props

    return onLeftHandlerMouseDown(e)
  }

  handleBodyMouseDown = e => {
    const {
      item: { onBodyMouseDown = noop },
      getItemProps,
      item,
      addEventData,
    } = this.props

    const { onMouseDown } = getItemProps()
    if (item.count) {
      addEventData(item, this.groupPosition)
    } else {
      onBodyMouseDown(e)
      addEventData(null)
    }

    onMouseDown(e)
  }

  render() {
    const {
      item,
      timelineContext,
      getItemProps,
      getResizeProps,
      planAllEventsValidate,
      irStatusAvailable,
      isPlanLocked,
    } = this.props

    const timelineItemProps = getItemProps()
    const {
      isPlan,
      planInfo,
      originId,
      start_time: start,
      end_time: end,
      color = `#eee`,
      leftHandlerStyle = {},
      rightHandlerStyle = {},
      timeLabel,
      status,
    } = item
    const { timelineWidth, visibleTimeStart, visibleTimeEnd } = timelineContext
    const eventStyleObj = this.calculateEventStyleObj(
      start,
      end,
      timelineWidth,
      visibleTimeStart,
      visibleTimeEnd,
      color,
    )
    const isItemLarge = get(eventStyleObj, `maxWidth`) > EVENT_WITH_STATUS_WIDTH
    const maxLeftRightWidth =
      get(eventStyleObj, `maxWidth`) < EVENT_WITH_STATUS_TOOLTIP
        ? (get(eventStyleObj, `maxWidth`) - 16) / 2
        : 16
    const showStatus = Boolean(irStatusAvailable && status && isItemLarge)
    const planLocked =
      (isPlan && isPlanLocked) || (!isPlan && get(planInfo, `locked`, false))
    const eventLocked = get(item, `original.locked`, false)
    const lockedColor = lockedStyle(makeTransparent(color, `0.4`))
    const {
      left: { ref: leftRef, style: leftStyle },
      right: { ref: rightRef, style: rightStyle },
    } = getResizeProps()
    const showLocked =
      (eventLocked || planLocked) &&
      !(isPlan && planAllEventsValidate[originId])
    const showLockedIcon = eventLocked || planLocked
    const ValidateStyle =
      planAllEventsValidate[originId] && planAllEventsValidate[originId].error
        ? errorStyle
        : warningStyle

    let invalidAttr
    if (isPlan && planAllEventsValidate[originId]) {
      if (planAllEventsValidate[originId].error)
        invalidAttr = `plan-calendar-kolbaska-error`
      if (!planAllEventsValidate[originId].error)
        invalidAttr = `plan-calendar-kolbaska-warning`
    }
    // validate OR locked OR clear event style
    let style
    if (isPlan && planAllEventsValidate[originId]) {
      style = {
        ...timelineItemProps.style,
        ...item.style,
        ...ValidateStyle,
      }
    } else if (showLocked) {
      style = {
        ...timelineItemProps.style,
        ...item.style,
        ...lockedColor,
      }
    } else {
      style = {
        ...timelineItemProps.style,
        ...item.style,
      }
    }

    const timeSpan = (
      <Transition
        in={Boolean(timeLabel)}
        timeout={100}
        mountOnEnter
        unmountOnExit
      >
        {state => (
          <span
            className={cn(
              styles[`item-title`],
              styles[`item-title_intangible`],
              { [styles[`item-title_invisible`]]: state === `entering` },
            )}
          >
            {timeLabel}
          </span>
        )}
      </Transition>
    )

    /*
     * A hack.
     * This is needed because the absolute positioning of timeSpan
     * does not stretch the item-container's width
     */
    const timeSpanStretcher = (
      <span
        className={cn(styles[`item-title`], styles[`item-title_stretcher`])}
      >
        {timeLabel}
      </span>
    )

    const eventItem = item.count ? (
      <div
        {...timelineItemProps}
        className={cn(timelineItemProps.className, styles.errorEvent)}
        onClick={this.handleOpen}
        style={style}
        onMouseDown={this.handleBodyMouseDown}
      >
        <div
          ref={element => {
            this.groupPosition = element
          }}
        >
          <div
            className={cn(
              `${timelineItemProps.className.replace(` `, ``)}-content`,
            )}
            style={eventStyleObj}
          >
            <div
              className={cn(styles[`custom-item`], styles[`group-count-space`])}
            >
              <div className={styles[`title-container`]}>
                <span
                  style={{
                    textAlign: `left`,
                  }}
                  className={styles[`item-title`]}
                >
                  Событий
                </span>
              </div>
            </div>
          </div>
          <span className={styles[`item-title-count`]}>{item.count}</span>
        </div>
      </div>
    ) : (
      <div
        {...timelineItemProps}
        className={timelineItemProps.className}
        onClick={this.handleOpen}
        style={style}
        onMouseDown={this.handleBodyMouseDown}
      >
        <div
          ref={leftRef}
          style={{
            ...leftStyle,
            ...leftHandlerStyle,
            width: `${maxLeftRightWidth}px`,
          }}
          onMouseDown={this.handleLeftHandleMouseDown}
        />
        <div
          ref={rightRef}
          style={{
            ...rightStyle,
            ...rightHandlerStyle,
            width: `${maxLeftRightWidth}px`,
          }}
          onMouseDown={this.handleRightHandleMouseDown}
        />
        <div
          className={`${timelineItemProps.className.replace(` `, ``)}-content`}
          style={eventStyleObj}
        >
          <div className={styles.TitleWithStatus}>
            {showStatus && (
              <div className={styles.EventStatusWrapper}>
                <TooltipSpan
                  tooltip={status.name}
                  tooltipConfig={{
                    placement: `top`,
                  }}
                >
                  <div
                    className={styles.EventStatus}
                    style={{ backgroundColor: status.color }}
                  />
                </TooltipSpan>
              </div>
            )}
            <div
              className={styles[`custom-item`]}
              style={{ paddingLeft: status ? `12px` : `0px` }}
            >
              <div
                className={cn(styles[`title-container`], {
                  [styles[`title-container_shifted`]]: Boolean(timeLabel),
                })}
              >
                <Box loose flex row className={styles[`item-title`]}>
                  <span>{item.name}</span>
                  {showLockedIcon && (
                    <TooltipSpan
                      tooltip="Заблокировано"
                      tooltipConfig={{
                        placement: `top`,
                      }}
                    >
                      <Box loose pl="2px">
                        <LockedIcon size="small" color="#8c8c8c" />
                      </Box>
                    </TooltipSpan>
                  )}
                </Box>
                {timeSpanStretcher}
                {timeSpan}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
    return invalidAttr ? (
      <div data-testid={invalidAttr}>{eventItem}</div>
    ) : (
      eventItem
    )
  }
}

const enhancer = compose(
  /* I need dispatch */
  connect((state, { item }) => {
    const planId = get(item, `planInfo.id`, false)
    return {
      planAllEventsValidate: selectViolationsList(state, `eventViolations`),
      irStatusAvailable: selectStatusAvailable(state),
      isPlanLocked: planId
        ? get(state, `entity.entities.plan.items.${planId}.data.locked`, false)
        : false,
    }
  }, null),

  contextConsumer,

  lifecycle({
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      /* The only way to pass `onSelect` function to the outside is this.
       * If you know the better way, lead the way */
      const { onSelect } = this.props
      this.props.overlay.registerChangeSelect(onSelect)
    },
  }),
)

export default enhancer(EventCard)
